import React from "react";
import "./DomainAndHosting.css";

const DomainAndHosting = () => {
  return (
    <div>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
      <p>this is DomainAndHosting</p>
    </div>
  );
};

export default DomainAndHosting;
